import script from "./TagsOptionsSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagsOptionsSkeleton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__